import { gql } from '@urql/core';
import React from 'react';
import { PlayerCardInfoPanelFragment } from '../../../generated/spin-graphql';

type Props = {
    className?: string;
    player: PlayerCardInfoPanelFragment;
};
gql`
    fragment PlayerCardInfoPanel on espin_player_profile {
        gpa
        graduating_class
    }
`;
export const PlayerCardInfoPanel: React.FC<Props> = ({ className, player }) => {
    return (
        <div className="player-info-panel">
            <div className="info-display">
                <p className="display-label">GPA</p>
                <div className="gpa display">{player.gpa}</div>
            </div>
            {player.graduating_class && (
                <div className="info-display">
                    <p className="display-label">Class</p>
                    <div className="year display">{player.graduating_class}</div>
                </div>
            )}
        </div>
    );
};
